module.exports = __webpack_public_path__ + "assets/63d028d56b1a01774b7a8523e9bbdbfc.mp3";